/* FD Duftfinder — Quizlogik zur Sektion fd-finder.liquid.
   Liest Produktdaten und Texte aus den JSON-Skripten der Sektion, leitet
   Merkmale ab, bewertet und zeigt das Ergebnis.

   Herkunft: theme/assets/fragrance-finder.js (SeventhScent). Uebernommen sind
   der Aufbau (Schritte, Punktevergabe, Ergebnis mit Alternativen) und die
   Entschaerfung der Shopify-Eigenheit, dass der `t`-Filter Locale-Texte
   HTML-maskiert (unesc unten).

   Bewusst anders als im Vorbild:

   * Treffer laufen ueber TAGS (Duftfamilie, Zielgruppe). Die Metafelder werden
     im FD-Shop je Sprache uebersetzt; ein Vergleich auf „holzig" wuerde auf der
     englischen Storefront still nichts mehr finden. Begruendung ausfuehrlich in
     fd-finder.liquid.
   * Die STAERKE kommt nicht aus der Konzentration. 130 der 131 Duefte sind
     Extrait de Parfum -- daraus abgeleitet waere die Frage nach der Intensitaet
     eine Frage ohne Wirkung, jedes Produkt haette denselben Wert. Getragen wird
     sie stattdessen von `vibe` (Intense, Soft, Smoky …) und `occasions`
     (After Dark vs. Office), also von echten, in allen Sprachen gleichen Daten.
   * Die Duftnoten gehen NICHT in die Punkte ein, nur in die Anzeige. Sie sind
     uebersetzt (Notenglossar), eine Stichwortsuche darauf traefe je Sprache
     unterschiedlich. Die Duftfamilie deckt dieselbe Aussage sprachfest ab.
   * Fehlende Angaben geben TEILPUNKTE statt null. Ein Duft ohne `occasions`
     widerspricht dem gewaehlten Anlass nicht, er sagt nur nichts dazu -- er
     darf deshalb nicht hinter einen Duft fallen, der aktiv nicht passt.
   * Keine Untergrenze bei der Prozentanzeige. Das Vorbild zeigte mindestens
     35 % Uebereinstimmung, auch bei null Punkten.
*/
(function () {
  'use strict';

  function norm(s) { return (s == null ? '' : String(s)).toLowerCase(); }
  function arr(x) { return Object.prototype.toString.call(x) === '[object Array]' ? x : []; }
  function uniq(a) { return a.filter(function (v, i) { return a.indexOf(v) === i; }); }
  function zaehle(werte, liste) {
    var n = 0;
    for (var i = 0; i < werte.length; i++) if (liste.indexOf(werte[i]) > -1) n++;
    return n;
  }
  function trifft(liste, werte) { return zaehle(werte, liste) > 0; }

  /* Duftrichtung -> Familien-Tags. Deutsche Schreibweise, weil Tags nie
     uebersetzt werden (produkte-anlegen.mjs setzt sie aus `familie`).
     Beide Schreibweisen mit und ohne Umlaut, damit ein spaeter anders
     geschriebener Tag nicht still durchfaellt. */
  var FAM = {
    frisch: ['frisch', 'zitrus', 'zitrisch', 'aquatisch', 'aromatisch', 'grün', 'gruen'],
    fruchtig: ['fruchtig'],
    bluemig: ['blumig', 'floral', 'pudrig'],
    warm: ['orientalisch', 'amber', 'gourmand', 'würzig', 'wuerzig', 'süß', 'suess'],
    holzig: ['holzig', 'chypre', 'fougère', 'fougere', 'ledrig']
  };
  var F_STARK = ['orientalisch', 'amber', 'gourmand', 'ledrig'];
  var F_LEISE = ['frisch', 'zitrus', 'zitrisch', 'aquatisch', 'pudrig'];
  var F_SOMMER = ['frisch', 'zitrus', 'zitrisch', 'aquatisch', 'grün', 'gruen', 'fruchtig', 'aromatisch'];
  var F_WINTER = ['orientalisch', 'amber', 'gourmand', 'holzig', 'würzig', 'wuerzig', 'süß', 'suess', 'chypre', 'ledrig'];

  /* Vibe-Begriffe sind in allen Sprachen gleich (texte-schreiben.mjs) und
     deshalb als Merkmal sicher. Nur eindeutige Begriffe stehen hier; „Elegant",
     „Chic", „Modern" sagen nichts ueber Lautstaerke oder Jahreszeit und bleiben
     absichtlich unbewertet. */
  var V_STARK = ['intense', 'bold', 'dark', 'deep', 'smoky', 'smoked', 'resinous', 'rich',
    'boozy', 'seductive', 'magnetic', 'sensual', 'electric', 'sharp', 'leather'];
  var V_LEISE = ['clean', 'soft', 'powdery', 'fresh', 'crisp', 'cool', 'silky', 'smooth',
    'effortless', 'mineral', 'intimate'];
  var V_SOMMER = ['fresh', 'crisp', 'cool', 'bright', 'luminous', 'clean', 'mineral',
    'green', 'citrus', 'vibrant', 'radiant', 'glowing'];
  var V_WINTER = ['warm', 'rich', 'deep', 'resinous', 'smoky', 'smoked', 'boozy', 'creamy',
    'dark', 'velvet', 'velvety', 'leather', 'amber'];
  var O_STARK = ['after dark', 'night out', 'date night'];
  var O_LEISE = ['office', 'everyday'];

  var STAERKE = { 1: 'leise', 2: 'mittel', 3: 'stark' };

  function ableiten(p) {
    var tags = arr(p.tags).map(norm);
    var vibe = arr(p.vibe).map(norm);
    var occ = arr(p.occ).map(norm);
    p.tg = tags;
    p.vibeRoh = arr(p.vibe);
    p.occRoh = arr(p.occ);
    p.occN = occ;

    // Zielgruppe aus dem Tag; fehlt der Tag, wird das Produkt spaeter nicht
    // ausgeschlossen (keine Angabe ist kein Widerspruch).
    p.ziel = tags.indexOf('damen') > -1 ? 'sie'
      : (tags.indexOf('herren') > -1 ? 'ihn' : (tags.indexOf('unisex') > -1 ? 'egal' : null));

    var stark = zaehle(vibe, V_STARK) + zaehle(occ, O_STARK) + zaehle(tags, F_STARK);
    var leise = zaehle(vibe, V_LEISE) + zaehle(occ, O_LEISE) + zaehle(tags, F_LEISE);
    p.staerkeBelegt = (stark + leise) > 0;
    p.staerke = stark > leise ? 3 : (leise > stark ? 1 : 2);

    p.sommer = (zaehle(vibe, V_SOMMER) + zaehle(tags, F_SOMMER) + (occ.indexOf('summer') > -1 ? 1 : 0)) > 0;
    p.winter = (zaehle(vibe, V_WINTER) + zaehle(tags, F_WINTER)) > 0;

    p.famText = arr(p.fam).join(' · ');
    // „N°118 After Dark" -> Nummer klein, Name gross. Passt der Titel nicht auf
    // das Schema, bleibt er unangetastet.
    var m = String(p.title || '').match(/^\s*(N[°o]\s*\d+)\s+(.+)$/i);
    p.nummer = m ? m[1] : '';
    p.name = m ? m[2] : (p.title || '');
    return p;
  }

  document.querySelectorAll('[data-fd-finder]').forEach(function (wurzel) {
    var sid = wurzel.id.replace(/^fd-finder-/, '');
    var datenEl = document.getElementById('fd-finder-data-' + sid);
    var textEl = document.getElementById('fd-finder-i18n-' + sid);
    var ikonenEl = document.getElementById('fd-finder-icons-' + sid);
    if (!datenEl || !textEl) return;

    var T, produkte;
    try {
      T = JSON.parse(textEl.textContent);
      produkte = JSON.parse(datenEl.textContent).map(ableiten);
    } catch (e) { return; }

    // Shopifys `t`-Filter maskiert Locale-Texte als HTML. Einmal zurueckdrehen,
    // damit das eigene esc() (fuer innerHTML) nicht doppelt maskiert („&amp;").
    function unesc(s) {
      return String(s).replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"').replace(/&#(?:39|x27);/g, "'");
    }
    (function tief(o) {
      if (o && typeof o === 'object') {
        for (var k in o) { if (typeof o[k] === 'string') o[k] = unesc(o[k]); else tief(o[k]); }
      }
    })(T);

    function esc(s) {
      return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }
    function icon(name) {
      var el = ikonenEl && ikonenEl.querySelector('[data-ic="' + name + '"]');
      return el ? el.innerHTML : '';
    }

    var anlaesse = arr(T.anlaesse);
    var schritte = [
      { key: 'wen', opts: [{ v: 'sie' }, { v: 'ihn' }, { v: 'egal' }], spalten: 3 },
      { key: 'richtung', opts: [{ v: 'frisch' }, { v: 'fruchtig' }, { v: 'bluemig' }, { v: 'warm' }, { v: 'holzig' }] },
      { key: 'staerke', opts: [{ v: 1, lk: 'leise' }, { v: 2, lk: 'mittel' }, { v: 3, lk: 'stark' }], spalten: 3, balken: true },
      { key: 'saison', opts: [{ v: 'sommer' }, { v: 'winter' }, { v: 'ganzjaehrig' }], spalten: 3 }
    ];
    // Die Anlassfrage kommt aus den Shopdaten. Steht dort nichts (frischer Shop,
    // Texte noch nicht gelaufen), wird sie weggelassen statt leer gezeigt.
    if (anlaesse.length) {
      schritte.splice(2, 0, { key: 'anlass', opts: anlaesse, ikonen: true });
    }

    var zahl = schritte.length;
    var antwortLeer = function () {
      var a = {};
      for (var i = 0; i < schritte.length; i++) a[schritte[i].key] = null;
      return a;
    };
    var stand = { schritt: 0, a: antwortLeer() };

    var schiene = wurzel.querySelector('.fd-finder__rail');
    var buehne = wurzel.querySelector('.fd-finder__step');

    function schieneSetzen() {
      var an = stand.schritt >= 1 && stand.schritt <= zahl;
      schiene.hidden = !an;
      if (!an) return;
      schiene.setAttribute('aria-valuemax', String(zahl));
      schiene.setAttribute('aria-valuenow', String(stand.schritt));
      schiene.querySelector('span').style.right = (100 - stand.schritt / zahl * 100) + '%';
    }
    function bauen(html, art) {
      var d = document.createElement('div');
      // Die Art steuert nur die Hoehe: Fragen halten eine feste Hoehe, damit
      // die Knoepfe beim Wechsel nicht springen; Einleitung und Leerzustand
      // sollen nicht auf 40rem aufgeblasen werden.
      d.className = 'fd-finder__step' + (art ? ' fd-finder__step--' + art : '');
      d.innerHTML = html;
      return d;
    }
    function tauschen(node) { buehne.replaceWith(node); buehne = node; }

    /* Punkte. `max` waechst mit den gestellten Fragen, damit die Prozentzahl
       auch stimmt, wenn die Anlassfrage fehlt. */
    function bewerten(p) {
      var a = stand.a, s = 0, max = 0, gruende = [];

      max += 3;
      if (a.richtung && trifft(FAM[a.richtung] || [], p.tg)) { s += 3; gruende.push(T.L[a.richtung]); }

      if (a.anlass) {
        max += 2.5;
        if (!p.occN.length) s += 1;
        else if (p.occN.indexOf(norm(a.anlass)) > -1) { s += 2.5; gruende.push(a.anlass); }
      }

      max += 2;
      if (!p.staerkeBelegt) s += 1;
      else {
        var d = Math.abs(p.staerke - a.staerke);
        if (d === 0) { s += 2; gruende.push(T.L[STAERKE[a.staerke]]); } else if (d === 1) s += 1;
      }

      max += 2;
      if (!p.sommer && !p.winter) s += 1;
      else if (a.saison === 'sommer') {
        if (p.sommer && !p.winter) { s += 2; gruende.push(T.L.sommer); } else if (p.sommer) s += 1;
      } else if (a.saison === 'winter') {
        if (p.winter && !p.sommer) { s += 2; gruende.push(T.L.winter); } else if (p.winter) s += 1;
      } else {
        if (p.sommer && p.winter) { s += 2; gruende.push(T.L.ganzjaehrig); } else s += 1;
      }

      // Ausverkauftes nicht als beste Empfehlung vorschlagen, aber auch nicht
      // verschweigen -- ein halber Punkt Abzug genuegt dafuer.
      if (p.available === false) s -= 0.5;

      /* Feinschliff entscheidet NUR die Reihenfolge unter Gleichstand, er geht
         nicht in die Prozentzahl ein. Grund: bei 131 Duefte erreichen viele
         dieselbe Punktzahl (der Katalog ist voll von holzig/intensiv/After
         Dark). Ohne Stichentscheid gewinnt dann die Reihenfolge im Katalog,
         also der Zufall. Mit ihm gewinnt der Duft, dessen Vibe-Begriffe in die
         gewaehlte Richtung am deutlichsten zeigen -- und die Prozentzahl bleibt
         erklaerbar: sie sagt weiter genau, wie viele der Antworten passen. */
      var vibe = p.vibeRoh.map(norm);
      var fein = 0;
      if (a.staerke === 3) fein += zaehle(vibe, V_STARK);
      if (a.staerke === 1) fein += zaehle(vibe, V_LEISE);
      if (a.saison === 'sommer') fein += zaehle(vibe, V_SOMMER);
      if (a.saison === 'winter') fein += zaehle(vibe, V_WINTER);
      if (p.occN.length) fein += 0.5;

      return {
        p: p, s: s, fein: fein,
        pct: Math.max(0, Math.round(s / max * 100)),
        gruende: uniq(gruende).slice(0, 4)
      };
    }

    function auswahl() {
      var wen = stand.a.wen;
      if (!wen || wen === 'egal') return produkte;
      return produkte.filter(function (p) { return !p.ziel || p.ziel === 'egal' || p.ziel === wen; });
    }

    // ---------- Ansichten ----------
    function intro() {
      /* Zweispaltig, weil das Briefing (§8) grosse leere Flaechen in einem Band
         ausdruecklich verbietet: einspaltig stand die rechte Haelfte leer.
         Die rechte Spalte listet die Fragen, die wirklich gestellt werden --
         also aus `schritte`, nicht aus einer zweiten Liste. Faellt die
         Anlassfrage weg (keine Daten), steht sie hier auch nicht. */
      var ablauf = schritte.map(function (st) {
        return '<li>' + esc(T.q[st.key]) + '</li>';
      }).join('');
      return bauen(
        '<div class="fd-finder__intro">' +
          '<div>' +
            '<p class="fd-finder__kicker">' + esc(T.eyebrow) + '</p>' +
            '<h2 class="fd-finder__h" tabindex="-1" data-kopf>' + esc(T.introTitle) + '</h2>' +
            '<p class="fd-finder__lead">' + esc(T.introLead) + '</p>' +
            '<div class="fd-finder__nav fd-finder__nav--start">' +
              '<button type="button" class="button" data-los>' + esc(T.introCta) + '</button>' +
              '<span class="fd-finder__hint">' + esc(T.introNote) + '</span>' +
            '</div>' +
          '</div>' +
          '<ol class="fd-finder__ablauf">' + ablauf + '</ol>' +
        '</div>',
        'intro'
      );
    }

    function beschriftung(st, o) {
      if (st.key === 'anlass') return o.v;
      return T.L[o.lk || o.v];
    }
    function unterzeile(st, o) {
      // Anlaesse sind Daten aus dem Shop. Zu den bekannten gibt es eine
      // uebersetzte Unterzeile, zu einem neuen Anlass nicht -- dann bleibt sie
      // leer, statt etwas zu behaupten.
      if (st.key === 'anlass') return (T.occSub && T.occSub[o.slug]) || '';
      return T.S[o.lk || o.v] || '';
    }

    function frage(st) {
      var gewaehlt = stand.a[st.key];
      var karten = st.opts.map(function (o) {
        var an = gewaehlt === o.v;
        var sub = unterzeile(st, o);
        var kopf = '';
        if (st.ikonen) kopf = '<span class="fd-icb" aria-hidden="true">' + icon(o.icon) + '</span>';
        else if (st.balken) {
          kopf = '<span class="fd-finder-opt__balken" aria-hidden="true">' +
            '<i></i><i' + (o.v > 1 ? '' : ' class="aus"') + '></i><i' + (o.v > 2 ? '' : ' class="aus"') + '></i></span>';
        }
        return '<button type="button" class="fd-finder-opt' + (an ? ' ist-gewaehlt' : '') + '"' +
          ' data-v="' + esc(o.v) + '" aria-pressed="' + (an ? 'true' : 'false') + '">' +
          kopf +
          '<span class="fd-finder-opt__tx"><b>' + esc(beschriftung(st, o)) + '</b>' +
          (sub ? '<small>' + esc(sub) + '</small>' : '') + '</span>' +
          '<span class="fd-finder-opt__tick" aria-hidden="true"></span></button>';
      }).join('');

      var nr = 0;
      for (var i = 0; i < schritte.length; i++) if (schritte[i].key === st.key) nr = i + 1;
      var zaehler = String(T.count || '%n% / %t%').replace('%n%', nr).replace('%t%', zahl);
      var titelId = 'fd-finder-q-' + sid;

      return bauen(
        '<p class="fd-finder__zaehler">' + esc(zaehler) + '</p>' +
        '<h2 class="fd-finder__h fd-finder__h--frage" id="' + titelId + '" tabindex="-1" data-kopf>' +
          esc(T.q[st.key]) + '</h2>' +
        '<div class="fd-finder__opts' + (st.spalten === 3 ? ' drei' : '') + '"' +
          ' role="group" aria-labelledby="' + titelId + '">' + karten + '</div>' +
        '<div class="fd-finder__nav">' +
          '<button type="button" class="button button--secondary" data-zurueck>' + esc(T.back) + '</button>' +
          '<button type="button" class="button" data-weiter' + (gewaehlt === null ? ' disabled' : '') + '>' +
            esc(nr === zahl ? T.showResult : T.next) + '</button>' +
        '</div>',
        'frage'
      );
    }

    function chips(titel, werte, klasse) {
      if (!werte.length) return '';
      return '<div class="fd-chips"><span class="fd-chips__titel">' + esc(titel) + '</span>' +
        werte.map(function (w) { return '<span class="fd-chip' + (klasse ? ' ' + klasse : '') + '">' + esc(w) + '</span>'; }).join('') +
        '</div>';
    }

    function leer() {
      return bauen(
        '<h2 class="fd-finder__h" tabindex="-1" data-kopf>' + esc(T.emptyTitle) + '</h2>' +
        '<p class="fd-finder__lead">' + esc(T.emptyText) + '</p>' +
        '<div class="fd-finder__nav fd-finder__nav--start">' +
          '<a class="button" href="' + esc(T.allUrl) + '">' + esc(T.emptyCta) + '</a>' +
          (stand.schritt > 0 ? '<button type="button" class="button button--secondary" data-neu>' + esc(T.restart) + '</button>' : '') +
        '</div>',
        'leer'
      );
    }

    function ergebnis() {
      var liste = auswahl();
      if (!liste.length) return leer();
      var rang = liste.map(bewerten).sort(function (a, b) {
        return (b.s - a.s) || (b.fein - a.fein) || (a.p.title < b.p.title ? -1 : 1);
      });
      var sieger = rang[0], andere = rang.slice(1, 3), d = sieger.p;

      var warum = sieger.gruende.map(function (g) {
        return '<span class="fd-chip fd-chip--occ">' + esc(g) + '</span>';
      }).join('');

      var alt = andere.map(function (r) {
        return '<a class="fd-finder-alt" href="' + esc(r.p.url) + '">' +
          '<span class="fd-finder-alt__bild"' + (r.p.img ? ' style="background-image:url(' + esc(r.p.img) + ')"' : '') + '></span>' +
          '<span class="fd-finder-alt__tx">' +
            (r.p.nummer ? '<small>' + esc(r.p.nummer) + '</small>' : '') +
            '<b>' + esc(r.p.name) + '</b>' +
            (r.p.hook ? '<em>' + esc(r.p.hook) + '</em>' : '') +
          '</span>' +
          '<span class="fd-finder-alt__pct">' + r.pct + '%</span></a>';
      }).join('');

      var node = bauen(
        '<p class="fd-finder__kicker">' + esc(T.resultEyebrow) + '</p>' +
        '<h2 class="fd-finder__h" tabindex="-1" data-kopf>' + esc(T.resultTitle) + '</h2>' +
        '<div class="fd-finder__res">' +
          '<div class="fd-finder__res-bild"' + (d.img ? ' style="background-image:url(' + esc(d.img) + ')"' : '') + '></div>' +
          '<div class="fd-finder__res-tx">' +
            (d.famText ? '<p class="fd-finder__fam">' + esc(d.famText) + '</p>' : '') +
            '<p class="fd-finder__name">' + (d.nummer ? '<span>' + esc(d.nummer) + '</span> ' : '') + esc(d.name) + '</p>' +
            (d.hook ? '<p class="fd-hook">' + esc(d.hook) + '</p>' : '') +
            '<div class="fd-finder__match">' +
              '<span class="fd-finder__pct">' + sieger.pct + '%</span>' +
              '<span class="fd-finder__balken"><i></i></span>' +
              '<span class="fd-finder__match-lab">' + esc(T.matchLabel) + '</span>' +
            '</div>' +
            (warum ? '<div class="fd-chips"><span class="fd-chips__titel">' + esc(T.because) + '</span>' + warum + '</div>' : '') +
            chips(T.vibeLabel, d.vibeRoh, '') +
            chips(T.occLabel, d.occRoh, 'fd-chip--occ') +
            '<div class="fd-finder__fakten">' +
              (d.conc ? '<div><span>' + esc(T.concLabel) + '</span>' + esc(d.conc) + '</div>' : '') +
              (arr(d.top).length ? '<div><span>' + esc(T.topLabel) + '</span>' + esc(arr(d.top).join(', ')) + '</div>' : '') +
              (d.price ? '<div><span>' + esc(T.priceLabel) + '</span>' + esc(d.price) +
                (d.unit ? '<small>' + esc(d.unit) + '</small>' : '') + '</div>' : '') +
            '</div>' +
            '<div class="fd-finder__cta">' +
              (d.available && d.vid
                ? '<button type="button" class="button" data-warenkorb="' + esc(d.vid) + '">' + esc(T.ctaCart) + '</button>'
                : '<span class="fd-finder__weg">' + esc(T.soldOut) + '</span>') +
              '<a class="button button--secondary" href="' + esc(d.url) + '">' + esc(T.ctaDetails) + '</a>' +
            '</div>' +
          '</div>' +
        '</div>' +
        (alt
          ? '<div class="fd-finder__alts"><h3>' + esc(T.altsTitle) + '</h3>' +
            '<p class="fd-finder__alts-sub">' + esc(T.altsSub) + '</p>' +
            '<div class="fd-finder__altgrid">' + alt + '</div></div>'
          : '') +
        '<div class="fd-finder__nav fd-finder__nav--mitte">' +
          '<button type="button" class="button button--secondary" data-neu>' + esc(T.restart) + '</button>' +
        '</div>',
        'res'
      );
      requestAnimationFrame(function () {
        var i = node.querySelector('.fd-finder__balken > i');
        if (i) i.style.width = sieger.pct + '%';
      });
      return node;
    }

    /* Fokus nach dem Neuzeichnen: bei einem Schrittwechsel auf die Ueberschrift
       (Screenreader liest die neue Frage), bei einer Auswahl zurueck auf die
       angeklickte Option -- sonst faellt der Fokus auf <body> und die
       Tastaturbedienung verliert ihren Platz. */
    function zeichnen(fokus) {
      schieneSetzen();
      var node;
      if (!produkte.length) node = leer();
      else if (stand.schritt === 0) node = intro();
      else if (stand.schritt <= zahl) node = frage(schritte[stand.schritt - 1]);
      else node = ergebnis();
      tauschen(node);
      if (fokus && fokus.wert != null) {
        var opts = node.querySelectorAll('.fd-finder-opt');
        for (var i = 0; i < opts.length; i++) {
          if (opts[i].getAttribute('data-v') === String(fokus.wert)) { opts[i].focus(); return; }
        }
      }
      if (fokus) { var k = node.querySelector('[data-kopf]'); if (k) k.focus(); }
    }

    function inWarenkorb(vid) {
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: 1 })
      }).then(function () { window.location = '/cart'; })
        .catch(function () { window.location = '/cart'; });
    }

    wurzel.addEventListener('click', function (e) {
      var t = e.target.closest('button, a');
      if (!t || !wurzel.contains(t)) return;
      if (t.hasAttribute('data-los')) { stand.schritt = 1; return zeichnen({}); }
      if (t.hasAttribute('data-zurueck')) { stand.schritt = Math.max(0, stand.schritt - 1); return zeichnen({}); }
      if (t.hasAttribute('data-weiter')) { stand.schritt++; return zeichnen({}); }
      if (t.hasAttribute('data-neu')) { stand.schritt = 0; stand.a = antwortLeer(); return zeichnen({}); }
      if (t.hasAttribute('data-warenkorb')) { e.preventDefault(); return inWarenkorb(t.getAttribute('data-warenkorb')); }
      if (t.classList.contains('fd-finder-opt')) {
        var st = schritte[stand.schritt - 1];
        if (!st) return;
        var v = t.getAttribute('data-v');
        if (st.key === 'staerke') v = parseInt(v, 10);
        stand.a[st.key] = v;
        return zeichnen({ wert: v });
      }
    });

    zeichnen();
  });
})();
